import { JwtHelperService } from '@auth0/angular-jwt';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { CompaniesService } from './companies.service';
import { ACCESS_TOKEN, REFRESH_TOKEN, TOKEN_TYPE } from '@constants/setting-keys.const';
import { enumUserRole } from '@data-layer/enums/user';
import { UsersRepository } from '@data-layer/repositories';
import { TokenModel } from '@data-layer/models/user';
import { Location } from '@angular/common';
import { ApplicationModeService } from './application-mode.service';
import { ApiService } from '@services/api.service';

@Injectable()
export class TokenService {
  private jwtHelper: JwtHelperService = new JwtHelperService();

  public constructor(
    private router: Router,
    private companiesService: CompaniesService,
    private applicationModeService: ApplicationModeService,
    private usersRepository: UsersRepository,
    private location: Location,
    private apiService: ApiService,
  ) {}

  public get isAuthenticated(): boolean {
    const token = this.getAccessToken();
    return !this.jwtHelper.isTokenExpired(token || null);
  }

  public setToken(token: TokenModel): void {
    localStorage.setItem(ACCESS_TOKEN, token.access_token);
    localStorage.setItem(REFRESH_TOKEN, token.refresh_token || null);
    localStorage.setItem(TOKEN_TYPE, token.token_type || 'Bearer');
  }

  public getAccessToken(): string {
    return localStorage.getItem(ACCESS_TOKEN) || null;
  }

  public getTokenType(): string {
    return localStorage.getItem(TOKEN_TYPE) || null;
  }

  public getRoles() {
    const decodeToken = this.jwtHelper.decodeToken(this.getAccessToken());
    return decodeToken.role || enumUserRole.USER.toString();
  }

  public getUID() {
    const decodeToken = this.jwtHelper.decodeToken(this.getAccessToken());
    return decodeToken.sub || '';
  }

  public getRefreshToken(): string {
    return localStorage.getItem(REFRESH_TOKEN) || null;
  }

  public eraseToken(goToLogin: boolean = true, saveUrl: boolean = true): void {
    if (!goToLogin) {
      this.eraseTokenState();
      return;
    }

    this.router.navigate(['auth', 'login'], saveUrl ? { queryParams: { returnUrl: this.location.path() } } : undefined).then(() => {
      this.eraseTokenState();
    });
    this.eraseTokenState();
  }

  public eraseTokenState(): void {
    const isHadToken: boolean = !!localStorage.getItem(ACCESS_TOKEN);
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_TYPE);
    this.companiesService.clearStateCompany();
    this.companiesService.clearStateUser();
    if (isHadToken) {
      this.apiService.destroyRequests();
    }
  }

  public refreshToken(refresh_token: string): Observable<TokenModel> {
    return this.usersRepository.refreshToken(refresh_token);
  }
}
